import React from 'react'

import { useTranslation } from 'react-i18next'

import classNames from 'classnames'
import ArrowRight from 'ziphy-web-shared/basic/assets/images/ui/right.svg'
import { Button } from 'ziphy-web-shared/basic/lib/buttons'
import { BubbleLoader } from 'ziphy-web-shared/basic/lib/loaders'

import { extendPlace } from '@helpers/addressHelper'

import SelectAddressMap from '../../../../pages/bookingHome/selectAddress/selectAddressMap/SelectAddressMap'
import styles from './SelectAddressMobile.module.scss'

const SelectAddressMobile = ({
  placeDetails,
  isDetailedPlace,
  isCollapsedMap,
  onClickBook,
  onClickChange,
}) => {
  const { t } = useTranslation()

  return (
    <div className={classNames(styles.mobile, { [styles.mobileMapHeight]: !isCollapsedMap })}>
      <div
        className={styles.mobileAddress}
        onClick={() => {
          if (isCollapsedMap) {
            onClickChange()
          }
        }}
      >
        {isCollapsedMap ? (
          <div className={styles.mobileAddressMeta}>
            {t('book_review.address')}
            <div className={styles.mobileAddressArrow}>
              <img className={styles.mobileAddressImage} src={ArrowRight} alt="" />
            </div>
          </div>
        ) : (
          <div className={styles.mobileAddressMeta}>{t('book_review.book_for')}</div>
        )}
        <div className={styles.mobileAddressTitle}>
          {isDetailedPlace ? extendPlace(placeDetails).buildingStreetCity() : <BubbleLoader />}
        </div>
      </div>
      <div className={classNames(styles.mobileMap, isCollapsedMap && styles.collapsed)}>
        <div className={styles.mobileMapInner}>
          <SelectAddressMap coords={placeDetails.coords} />
        </div>
        <div className={styles.mobileMapButtonsWrapper}>
          <div className={styles.mobileMapButton}>
            <Button mode={['primary', 'block']} onClick={onClickBook}>
              {t('btn.book_here')}
            </Button>
          </div>
          <div className={styles.mobileMapButton}>
            <Button mode={['white', 'block']} onClick={onClickChange}>
              {t('btn.change_address')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectAddressMobile
